export const RQ_GET_ALL_USER_PRODUCT_API = {
  url: 'api/order/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_PUT_UPDATE_ORDER_API = {
  url: 'api/order/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};
